import { config } from '@/config'

export default class FilterMadamesum {
	static install(Vue, options = {}) {
		Vue.filter('madpricecent', function (value, mode = "long") {
			let prefix = ""
			if (mode == "long") {
				prefix = config.THEME_CURRENCY_PREFIX || ''
			}
			else if (mode == "html") {
				prefix = (config.THEME_CURRENCY_PREFIX || '').replace(' ', '&nbsp;')
			}

			let v = value / 100
			v = v || 0
			return prefix + v.toFixed(2)
		})
		Vue.filter('madcmstext', function (value) {
			let type = typeof value
			if (type == "string") {
				return value
					.replace(/(\r\n|\n)/g, "<br>")
			} else if (type == "number") {
				return value.toString()
			}
			return ""
		})
	}
}
